import React from 'react';

export default function PolyethyleneTankIcon({
  width = 64,
  height = 43,
  startColor = '#373737',
  midColor = '#EBEBEB',
  endColor = '#373737'
}) {
  const id = Math.random().toString(36).slice(2, 9);
  return (
    <svg width={width} height={height} viewBox="0 0 112.5 76.125" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id={`fp-shadow-${id}`} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="2.5"/>
          <feOffset dx="0" dy="3" result="offsetblur"/>
          <feComponentTransfer><feFuncA type="linear" slope="0.45"/></feComponentTransfer>
          <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <radialGradient id={`fp-shine-${id}`} cx="35%" cy="22%" r="65%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.28)"/>
          <stop offset="55%" stopColor="rgba(255,255,255,0.06)"/>
          <stop offset="100%" stopColor="rgba(255,255,255,0)"/>
        </radialGradient>
      </defs>
      <g filter={`url(#fp-shadow-${id})`}>
      <g id="Group_TankBody">
	<linearGradient id={`${id}_1_`} gradientUnits="userSpaceOnUse" x1="56.2505" y1="66.6663" x2="56.2505" y2="10.4734">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.45" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.55" style={{stopColor: "#D8D8D8"}} />
		<stop offset="0.76" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.77" style={{stopColor: "#A5A5A5"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<path fill={`url(#${id}_1_)`} d="M105.518,10.473c4.04,0,6.982,23.423,6.982,23.423v9.348c0,0-3.648,23.423-6.982,23.423H6.87   C1.985,63.009,0,43.243,0,43.243v-9.348c0,0,1.647-23.423,6.869-23.423" />
</g>
<g id="Group_Top">
	<linearGradient id={`${id}_2_`} gradientUnits="userSpaceOnUse" x1="43.2432" y1="0.5071" x2="69.1445" y2="0.5071">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.45" style={{stopColor: "#989898"}} />
		<stop offset="0.62" style={{stopColor: "#858585"}} />
		<stop offset="0.77" style={{stopColor: "#727272"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_2_)`} d="M43.243,0h25.901v1.014H43.243V0z" />
	<linearGradient id={`${id}_3_`} gradientUnits="userSpaceOnUse" x1="42.1172" y1="7.3196" x2="70.7207" y2="7.3196">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.45" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.55" style={{stopColor: "#D8D8D8"}} />
		<stop offset="0.76" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.77" style={{stopColor: "#A5A5A5"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<path fill={`url(#${id}_3_)`} d="M70.721,0.563v10.586c0,0-3.887,2.928-14.471,2.928c-10.625,0-14.133-2.928-14.133-2.928V0.563   H70.721z" />
</g>
<g id="Group_Fill">
	<linearGradient id={`${id}_4_`} gradientUnits="userSpaceOnUse" x1="56.1934" y1="43.2434" x2="56.1934" y2="66.6663">
		<stop offset="0" style={{stopColor: "#BABABA"}} />
		<stop offset="0.22" style={{stopColor: "#A3A3A3"}} />
		<stop offset="0.68" style={{stopColor: "#676767"}} />
		<stop offset="1" style={{stopColor: "#3A3A3A"}} />
	</linearGradient>
	<path fill={`url(#${id}_4_)`} d="M9.347,43.243h93.693v23.423H9.347V43.243z" />
</g>
<g id="Group_FrontLegs">
	<linearGradient id={`${id}_5_`} gradientUnits="userSpaceOnUse" x1="22.1851" y1="47.9729" x2="22.1851" y2="10.4734">
		<stop offset="0" style={{stopColor: "#BABABA"}} />
		<stop offset="0.22" style={{stopColor: "#A3A3A3"}} />
		<stop offset="0.68" style={{stopColor: "#676767"}} />
		<stop offset="1" style={{stopColor: "#3A3A3A"}} />
	</linearGradient>
	<path fill={`url(#${id}_5_)`} d="M18.582,10.473h7.207v37.5h-7.207V10.473" />
	<linearGradient id={`${id}_6_`} gradientUnits="userSpaceOnUse" x1="90.0898" y1="47.9729" x2="90.0898" y2="10.4734">
		<stop offset="0" style={{stopColor: "#BABABA"}} />
		<stop offset="0.22" style={{stopColor: "#A3A3A3"}} />
		<stop offset="0.68" style={{stopColor: "#676767"}} />
		<stop offset="1" style={{stopColor: "#3A3A3A"}} />
	</linearGradient>
	<path fill={`url(#${id}_6_)`} d="M86.6,10.473h6.981v37.5H86.6V10.473" />
	<path fill="#878787" d="M18.582,47.973l-2.252,28.152h11.711l-2.252-28.152H18.582z" />
	<path fill="#878787" d="M86.6,47.973l-2.253,28.152h11.712l-2.478-28.152H86.6z" />
</g>
    
      </g>
      <rect x="0" y="0" width="112.5" height="76.125" fill={`url(#fp-shine-${id})`} style={{pointerEvents:"none"}}/>
    </svg>
  );
}
